import React, {
	useContext,
	lazy,
	Suspense,
	LazyExoticComponent,
	ComponentType,
} from 'react';
import { Container } from './Content.styles';
import { CandidateContext, ICandidate } from '../../CandidateFormProvider';

interface IComponents {
	[key: number]: LazyExoticComponent<ComponentType<any>>;
}

const Forms: IComponents = {
	0: lazy(() =>
		import('../Candidate/Candidate').then((module) => ({
			default: module.Candidate,
		})),
	),
	1: lazy(() =>
		import('../Appointment/Appointment').then((module) => ({
			default: module.Appointment,
		})),
	),
};

export const Content = () => {
	const { activeStep } = useContext<ICandidate>(CandidateContext);
	const ActiveComponent = Forms[activeStep];

	return (
		<Container>
			<Suspense fallback={<div />}>
				<ActiveComponent />
			</Suspense>
		</Container>
	);
};
